import React from 'react';
import * as Ui from './styles';
import { SettingsIcon } from '../../../Icons';

/**
 * Componente de item de menu, que serve de gatilho
 * para a configuracao de resultados de um card
 */
function ResultConfigurationMenu({
  /**
   * Titulo a ser exibido no menu
   */
  title = 'Configurações',
  /**
   * Titulo de hover do menu
   */
  hoverTitle = 'Configurar resultados',
  /**
   * Callback para click no menu
   */
  onConfigClick,
  /**
   * others
   */
  ...props
}) {
  // props from styled-components
  const { className, withSettings } = props;

  function onClick() {
    if (onConfigClick && withSettings) {
      onConfigClick();
    }
  }

  return (
    <Ui.Container withSettings={withSettings} className={className} onClick={onClick} title={hoverTitle}>
      <Ui.IconContainer>
        <SettingsIcon className="icon" color="#610082" />
      </Ui.IconContainer>
      <span>{title}</span>
    </Ui.Container>
  );
}

export default ResultConfigurationMenu;
